import React from 'react';
import Download from "../elements/download";

interface Props {
    onDownload: (data?: any) => void;
    releases: any[];
};

const Community = (props: Props) => {
    const { onDownload, releases } = props;

    return (
	<div id="Mark2" className="section community">
	    <h2>Join communication network no single party controls</h2>

	    <Download onDownload={onDownload} items={releases} />
	</div>
    );
};

export default Community;